<template>
    <div id="atmo-supplier-info" class="atmo-hash-jump-point atmo-content-group">
        <h3>Информация о поставщике (исполнителе)</h3>

        <ul v-if="!this.$props.purchaseitem.is_individual_supplier" class="atmo-content-block-2-columns atmo-no-item-separator">
            <li class="mb-2 pb-2">
                <dt>Наименование:</dt>
                <dd><a v-bind:href="`/organizations/${this.$props.supplier.id}`" v-text="this.$props.supplier.title"></a></dd>
            </li>
            <li class="mb-2 pb-2">
                <dt>ИНН:</dt>
                <dd v-text="this.$props.supplier.inn"></dd>
            </li>
            <li v-if="this.$props.supplier.kpp" class="mb-2 pb-2">
                <dt>КПП:</dt>
                <dd v-text="this.$props.supplier.kpp"></dd>
            </li>
            <li class="mb-2 pb-2">
                <dt>Адрес:</dt>
                <dd v-text="this.$props.supplier.address"></dd>
            </li>
            <li v-if="$props.purchaseitem.supplierOrganizationCardAttachment !== null" class="mb-2 pb-2">
                <dt>Карточка предприятия:</dt>
                <dd><a :href="$getAttachmentDownloadLink($props.purchaseitem.supplierOrganizationCardAttachment.id)" class="atmo-button-link" v-text="$props.purchaseitem.supplierOrganizationCardAttachment.name"></a></dd>
            </li>
        </ul>

        <ul v-else class="atmo-content-block-2-columns atmo-no-item-separator">
            <li class="mb-2 pb-2">
                <dt>Наименование:</dt>
                <dd>Физическое лицо</dd>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        pivc: { required: true, type: Object },
        purchaseitem: { required: true, type: Object },
        supplier: { required: true, type: Object }
    }
};
</script>
